import React, { SVGProps } from 'react';
export const AttoLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Atto logo"
    data-testid="atto_logo"
    viewBox="0 0 162.7 61.67"
    {...props}
  >
    <style>
      {
        '@keyframes a-enter{0%{transform:translate(0,100%)}to{transform:translate(0,0)}}@keyframes tt-enter{0%{transform:translate(0,100%)}to{transform:translate(0,0)}}@keyframes o-enter{0%{transform:translate(0,100%) rotate(90deg)}to{transform:translate(0,0) rotate(0deg)}}@keyframes blur-animation{0%{filter:blur(3px) opacity(25%)}25%{filter:blur(2px) opacity(100%)}to{filter:blur(0)}}@keyframes o-spinner{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}'
      }
    </style>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 47.95c0-8.74 7.22-12.29 15.66-14.04 10.96-2.27 14.44-2.6 14.44-6.32 0-3.45-3.05-6.04-7.74-6.04-3.77 0-7.04 1.7-8.84 5.74-.42.95-1.5 1.45-2.5 1.12l-7.87-2.55c-.92-.3-1.42-1.32-1.05-2.22 3.5-8.57 11.86-11.69 20.71-11.69 12.01 0 19.58 5.72 19.58 16.66v16.98c0 5.97.37 9.27.97 12.19.27 1.27-.7 2.45-1.97 2.45H33.4c-.92 0-1.75-.65-1.97-1.55-.35-1.47-.5-2.97-.5-4.6h-.17c-2.52 4.62-8.09 7.57-14.44 7.57C8 61.63.01 57.18.01 47.94Zm30.17-5.39v-3.8c-2.52 1-6.79 2.1-9.49 2.6-3.82.92-7.39 2.7-7.39 6.22s2.77 4.97 6.52 4.97c6.47.02 10.37-5.2 10.37-9.99Z"
      clipRule="evenodd"
      style={{
        animation: 'a-enter .7s cubic-bezier(.16,.56,.1,1.21) 1s,blur-animation .8s cubic-bezier(.16,.56,.1,1) 1s',
        animationFillMode: 'forwards',
        transform: 'translate(0,100%)',
        filter: 'blur(3px) opacity(0%)'
      }}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M111.09 51.38c0-.95-.95-1.6-1.82-1.27-1.47.55-3.05.87-4.7.87-6.62 0-6.62-5.47-6.62-9.92V23.98h11.11c1.12 0 2.02-.9 2.02-2.02v-6.64c0-1.12-.9-2.02-2.02-2.02H97.95V2.02C97.95.9 97.05 0 95.93 0h-8.12c-1.12 0-2.02.9-2.02 2.02v11.26H66.66V2.02C66.66.9 65.76 0 64.64 0h-8.12C55.4 0 54.5.9 54.5 2.02v11.26h-7.54c-1.12 0-2.02.9-2.02 2.02v6.62c0 1.12.9 2.02 2.02 2.02h7.54v21.28c0 4.87 0 16.41 16.26 16.41 2.82 0 5.52-.35 7.74-1.2.77-.3 1.3-1.05 1.3-1.9v-7.19c0-.95-.95-1.6-1.82-1.27-1.47.55-3.05.87-4.7.87-6.62 0-6.62-5.47-6.62-9.92V23.96h19.13v21.28c0 4.87 0 16.41 16.26 16.41 2.82 0 5.52-.35 7.74-1.2.77-.3 1.3-1.05 1.3-1.9v-7.19Z"
      clipRule="evenodd"
      style={{
        animation: 'tt-enter .7s cubic-bezier(.16,.56,.1,1.21) 1.1s,blur-animation .8s cubic-bezier(.16,.56,.1,1) 1.1s',
        animationFillMode: 'forwards',
        transform: 'translate(0,100%)',
        filter: 'blur(3px) opacity(0%)'
      }}
    />
    <g
      style={{
        position: 'relative',
        transformBox: 'fill-box',
        transformOrigin: 'center',
        animation:
          'o-enter .7s cubic-bezier(.16,.56,.1,1.21) 1.15s,blur-animation .8s cubic-bezier(.16,.56,.1,1.21) 1.15s,o-spinner 1.4s cubic-bezier(.16,.56,.1,1.15) 1.85s',
        animationFillMode: 'forwards',
        transform: 'translate(0,100%)',
        filter: 'blur(3px) opacity(0%)'
      }}
    >
      <path
        id="logo-o-top"
        fill="currentColor"
        fillRule="evenodd"
        d="M126.75 43.26c-1.12-1.9-1.75-4.12-1.75-6.47 0-7.04 5.79-12.81 12.81-12.81 2.37 0 4.57.65 6.47 1.75.47.27 1.1.2 1.5-.2l6.87-6.87c.55-.55.47-1.45-.15-1.9-4.2-3.1-9.42-4.9-15.04-4.82-13.41.17-24.35 11.11-24.53 24.53-.07 5.62 1.72 10.84 4.82 15.04.45.62 1.35.67 1.9.15l6.87-6.87c.42-.4.5-1.02.22-1.52Z"
        clipRule="evenodd"
      />
      <path
        id="logo-o-bottom"
        fill="currentColor"
        fillRule="evenodd"
        d="m155.98 21.95-6.87 6.87c-.4.4-.47 1.02-.2 1.5 1.12 1.9 1.75 4.12 1.75 6.47 0 7.04-5.79 12.81-12.81 12.81-2.37 0-4.57-.65-6.47-1.75-.47-.27-1.1-.2-1.5.2l-6.89 6.89c-.55.55-.47 1.45.15 1.9 4.2 3.1 9.42 4.9 15.04 4.82 13.41-.17 24.35-11.11 24.53-24.53.07-5.62-1.72-10.84-4.82-15.04-.47-.62-1.37-.7-1.9-.15Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
